import { RefObject, useCallback, useEffect, useRef } from "react";
import { DropResult } from "react-beautiful-dnd";
import { UseFieldArrayReturn } from "react-hook-form";
import { FormType } from "../common/form";
import { ISinglePageRefType } from "./single-page";

export const useDragCallbacks: (
  pages: UseFieldArrayReturn<FormType, "pages", "id">
) => {
  onDragEnd: ({ source, destination, draggableId }: DropResult) => void;
  pageRefs: RefObject<Map<number, ISinglePageRefType | null>>;
} = (pages) => {
  const pageRefs = useRef<Map<number, ISinglePageRefType | null>>(
    new Map()
  ) as any;

  useEffect(() => {
    pageRefs.current = new Map();
  }, [pages.fields]);

  const onDragEnd = useCallback(
    ({ source, destination, draggableId }: DropResult) => {
      // dropped inside of the list
      if (source && destination) {
        // source container index and id
        const { index: sourceIndex, droppableId: sourceId } = source;

        // destination container index and id
        const {
          index: destinationIndex,
          droppableId: destinationId,
        } = destination;

        // source container object
        const sourceContainer: any = pages.fields!.find(
          (column) => column.id === sourceId
        );

        // desination container object
        const destinationContainer: any = pages.fields!.find(
          (column) => column.id === destinationId
        );

        const sourceContainerIndex = pages.fields.findIndex(
          (column) => column.id === sourceId
        );
        // check if source and destination container are the same
        if (sourceContainer?.id === destinationContainer?.id) {
          pageRefs.current
            ?.get(sourceContainerIndex)
            .moveItem(sourceIndex, destinationIndex);
        } else {
          const destinationContainerIndex = pages.fields.findIndex(
            (column) => column.id === destinationId
          );
          const obj = pageRefs.current
            ?.get(sourceContainerIndex)
            .getItem(sourceIndex);

          pageRefs.current
            ?.get(destinationContainerIndex)
            .insertItem(destinationIndex, obj);
          pageRefs.current?.get(sourceContainerIndex).removeItem(sourceIndex);
        }
      }
    },
    [pageRefs]
  );

  return { pageRefs, onDragEnd };
};
